import { render, staticRenderFns } from "./IconSvgCsv.vue?vue&type=template&id=2c8ce00e&scoped=true&"
import script from "./IconSvgCsv.vue?vue&type=script&lang=js&"
export * from "./IconSvgCsv.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8ce00e",
  null
  
)

export default component.exports